import { combineReducers } from "@reduxjs/toolkit";
import aConsoleDataReducer from "./aConsoleData";
import emailNotificationStatusesReducer from "./emailNotificationStatuses";
import globalMessageTypesReducer from "./globalMessageTypes";
import referenceDataDomainsReducer from "./referenceDataDomains";
import countriesDataReducer from "./countriesData";
import nationalUniversitiesDataReducer from "./nationalUniversitiesData";
import receiveResultReducer from "./receiveResult";
import foreignIdReducer from "./foreignId";
import humanitarianStatus from "./humanitarianStatus";
import countryRegionsReducer from "./countryRegions";
import eqfStatusesReducer from "./eqfStatuses";
import systemTypesReducer from "./systemTypes";

const appDataReducers = combineReducers({
  aConsoleData: aConsoleDataReducer,
  emailNotificationStatuses: emailNotificationStatusesReducer,
  globalMessageTypes: globalMessageTypesReducer,
  referenceDataDomains: referenceDataDomainsReducer,
  countriesData: countriesDataReducer,
  nationalUniversitiesData: nationalUniversitiesDataReducer,
  receiveResult: receiveResultReducer,
  foreignId: foreignIdReducer,
  humanitarianStatus: humanitarianStatus,
  countryRegions: countryRegionsReducer,
  eqfStatuses: eqfStatusesReducer,
  systemTypes: systemTypesReducer,
});

export default appDataReducers;
